
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { commonApi } from "@/common/index";
import { manageOptions } from "../../../libs/options.js";
export default {
components: { Cell, Confirm, Group, XSwitch, XButton },
inject: ["parentRoot"],
directives: {
TransferDom,
},
data() {
return {
confirm: {
show: false,
confirmText: "",
content: "",
path: "",
telegram_credential: window.telegram_credential,
},
};
},
computed: {
manageLists() {
let {
userAccount,
mobilePhone,
mobileValid,
name,
nameValid,
email,
emailValid,
} = this.$store.state.userInfo.userInfo;
let list = [];
for (let i in manageOptions) {
let item = Object.assign({}, manageOptions[i]);
if (this.$t("mine").accountManage[item.langKey])
item.text = this.$t("mine").accountManage[item.langKey];
if (this.$t("mine").accountManage[item.langKey2])
item.value = this.$t("mine").accountManage[item.langKey2];
if (item.langKey === "nickName") item.value = userAccount;
if (item.langKey === "name") item.value = nameValid ? name : item.value;
if (item.langKey === "phone")
item.value = mobileValid ? mobilePhone : item.value;
if (item.langKey === "email")
item.value = emailValid ? email : item.value;
if (
item.langKey === "nickName" ||
(item.langKey === "name" && nameValid) ||
(item.langKey === "phone" && mobileValid) ||
(item.langKey === "email" && emailValid)
)
item.valchange = true;
list.push(item);
}
return list;
},
},
created() {


},
methods: {
handleClick({ path, Valid, tipsKey, langKey }) {
if (Valid && this.$store.state.userInfo.userInfo[Valid]) {
if (tipsKey) {
this.confirm.content =
this.$t("ValidTips")[tipsKey] + this.$t("ValidTips").conactService;
this.confirm.confirmText = this.$t("others").CustomerService;
this.confirm.path = "/Service";
}
this.confirm.show = true;
return;
}

if (
langKey === "drawPws" &&
this.$store.state.linkList.withdrawMethod === "0" &&
!this.$store.state.userInfo.userInfo.mobileValid
) {
this.confirm.content = this.$t("ValidTips").noPhone;
this.confirm.confirmText = this.$t("register").authenticateNow;
this.confirm.path = "/My/AccountManat/mobileAuth";
this.confirm.show = true;
return;
}
if (path) this.$router.push({ path });
},
onConfirm() {
this.$router.push({ path: this.confirm.path });
},
handOutLoigin(path) {
this.$store
.dispatch("Logout")
.then(() => {

this.$vux.toast.show({
text: this.$t("mine").accountManage.loiginOut,
type: "success",
});
if (this.parentRoot.FirebaseSignOut)
this.parentRoot.FirebaseSignOut(); 
})
.catch((msg) => {
this.$vux.toast.show({ text: msg, type: "cancel" });
});
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/accountmanat.bak.vue